export default {
    solarSimpleTariffsDataBegin(state) {
        state.loadingTariffs = true;
    },
    solarSimpleTariffsDataSuccess(state, data) {
        state.pageSize = data.per_page;
        state.tariffs = data.data;
        state.count = data.total;
        state.currentPage = data['current_page'];
        state.loadingTariffs = false;
    },
    solarSimpleTariffsDataErr(state, err) {
        state.loadingTariffs = false;
        state.errorTariffs = err;
    },
    solarSimpleTariffDataCreateBegin(state) {
        state.errorCreateTariff = false;
        state.loadingCreateTariff = true;
    },
    solarSimpleTariffDataCreateSuccess(state) {
        state.loadingCreateTariff = false;
    },
    solarSimpleTariffDataCreateErr(state, err) {
        state.loadingCreateTariff = false;
        state.errorCreateTariff = err;
    },
    solarSimpleTariffDataPatchBegin(state) {
        state.loadingPatchTariff = true;
    },
    solarSimpleTariffDataPatchSuccess(state) {
        state.loadingPatchTariff = false;
    },
    solarSimpleTariffDataPatchErr(state, err) {
        state.loadingPatchTariff = false;
        state.errorPatchTariff = err;
    },
    setCurrentSolarSimplePage(state, page) {
        state.currentPage = page;
    },
};
